module.exports = __webpack_public_path__ + "img/smile.0b63bd0b.svg";